import { toTitleCase } from "../../../../Utils/stringUtls";
import ReviewAttribute from "../../../../Components/SharedComponent/ReviewAttribute/ReviewAttribute";
import ReviewSummarySectionHeading from "../../../../Components/SharedComponent/ReviewSummarySectionHeading/ReviewSummarySectionHeading";
import { formatReviewDate } from "../reviewSummaryUtils";

const CompanyInformation = ({ data, type = "debit" }) => {
  let data1 = data?.["1_2"];

  data1 = data?.["0_2"];
  const {
    ci_businessName,
    ci_physicalAddress,
    ci_mailingAddress,
    ci_companyFax,
    ci_companyPhone,
    ci_companyPhoneCountry,
    ci_companyWebURL,
    ci_otherBusinessLoc,
    ci_date_business_established,
  } = data1;
  return (
    <div className="forms-instance" style={{ color: "#111" }}>
      <div i2c-grid="grid" className="review-summary-gap">
        <ReviewSummarySectionHeading title="Client Information" />
        <ReviewAttribute
          label="Trade or Business Name"
          value={toTitleCase(ci_businessName)}
        />
        <ReviewAttribute
          label="Company Phone"
          value={
            ci_companyPhone
              ? `${ci_companyPhoneCountry} - ${ci_companyPhone}`
              : '-'
          }
        />
        <ReviewAttribute
          label="Physical Address"
          value={ci_physicalAddress ? toTitleCase(ci_physicalAddress) : '-'}
        />
        <ReviewAttribute
          label="Mailing Address"
          value={ci_mailingAddress ? toTitleCase(ci_mailingAddress) : '-'}
        />
        <ReviewAttribute
          label="Company Website URL"
          value={ci_companyWebURL ? ci_companyWebURL : '-'}
        />
        <ReviewAttribute
          label="Other Business Locations"
          value={ci_otherBusinessLoc ? toTitleCase(ci_otherBusinessLoc) : '-'}
        />
        <ReviewAttribute
          label="Date Business Established"
          value={ci_date_business_established ? formatReviewDate(ci_date_business_established) : '-'}
        />
      </div>
      <div className="divider-bottom mt-16"></div>
    </div>
  );
};
export default CompanyInformation;
